/**
 * 견줄 이웃 한 줄 세우기 — 상위 브랜드 목록에 **이 브랜드**를 끼워 넣는다.
 *
 * ⚠️ 상위 목록 밖이면 순위를 목록 자리로 적지 않는다 — 제 순위를 달고 맨 뒤에 붙인다.
 */

export type BrandRankRow = { brand: string; mentions: number };

/** 견줄 한 줄 — 제 순위를 달고 온다(상위 밖에서 끌어온 줄도 제 순위를 쥔다 · 번호를 비우면 `null`) */
export type BrandPeer = BrandRankRow & { rank: number | null; self: boolean };

/** 견줄 이웃으로 세우는 상위 줄 수 */
export const BRAND_PEER_TOP = 20;

/**
 * 견줄 이웃 — 상위 몇 과 **이 브랜드**를 한 줄로 세운다(이 브랜드가 상위 밖이면 맨 뒤에 붙인다).
 * @param top 상위 몇 개까지 세울지 — 기본 스물(허브 오른쪽 칸은 스스로 스크롤한다)
 * @param selfRank 거짓이면 상위 밖에서 끌어온 이 브랜드 줄의 번호를 비운다(`null`)
 */
export function toBrandPeers(brand: string, rows: BrandRankRow[], top = BRAND_PEER_TOP, selfRank = true): BrandPeer[] {
  const key = brand.trim().toLowerCase();
  const head = rows.slice(0, top).map((row, i) => ({ ...row, rank: i + 1, self: row.brand.trim().toLowerCase() === key }));
  if (head.some((row) => row.self)) return head;
  // ⚠️ 상위 밖에서 끌어올 때는 **제 순위**를 함께 싣는다 — 줄 번호를 적으면 맨 뒷자리를 제 순위라고 거짓말한다
  const index = rows.findIndex((row) => row.brand.trim().toLowerCase() === key);
  return index < 0 ? head : [...head, { ...rows[index], rank: selfRank ? index + 1 : null, self: true }];
}
